import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageType } from '@medicalapp/shared-core';
import { MessageSnackbarComponent } from '@shared/components/message-snackbar/message-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private snackBar: MatSnackBar) { }

  /**
   * Display a global toast notification snackbar.
   * @param message Text notification content
   * @param type Message severity type (Success, Error, Warning, Info)
   */
  showMessage(message: string, type: MessageType) {
    this.snackBar.openFromComponent(MessageSnackbarComponent, {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      data: {
        message: message,
        type: type,
        icon: this.getAlertIconUrl(type),
        panelClass: this.getPanelClass(type),
      },
    });
  }

  private getPanelClass(type: MessageType): string {
    switch (type) {
      case MessageType.Success:
        return 'success';
      case MessageType.Error:
        return 'error';
      case MessageType.Warning:
        return 'warn';
      case MessageType.Info:
        return 'info';
      default:
        return '';
    }
  }

  private getAlertIconUrl(type: MessageType): string {
    switch (type) {
      case MessageType.Success:
        return '/assets/images/ic-snackbar-success.svg';
      case MessageType.Error:
        return '/assets/images/ic-snackbar-error.svg';
      case MessageType.Warning:
        return '/assets/images/ic-snackbar-warn.svg';
      case MessageType.Info:
        return '/assets/images/ic-snackbar-info.svg';
      default:
        return '';
    }
  }
}
